import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import useApiManager from '../../utils/Api/apiManager';

const CampaignsAutoComplete = ({ setCampaignId, campaignId, shouldFetchSingleCampaign, small = false, fullWidth = true }) => {
    const [campaignOptions, setCampaignOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [loading, setLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [inputValue, setInputValue] = useState('');
    const pageSize = 6;
    const { post, get } = useApiManager();

    const fetchAndSetData = async (pageNum, inputText) => {
        try {
            setLoading(true);

            const payload = {
                pageNumber: pageNum,
                pageSize,
                filters: [
                    {
                        fieldName: 'campaignName', // Filter field
                        filterOperator: 2, // Example: "contains" operator
                        fieldValue: inputText || '', // Use inputValue for filtering
                        fieldType: 1, // Example: string field type
                    },
                ],
                sortField: '', // Optional: Add sort field if needed
                sortDescending: false, // Optional: Set sorting direction
            };

            const response = await post('/campaigns/paged', payload);

            const options = response.items.map(campaign => ({
                label: campaign.campaignName,
                value: campaign.id,
            }));

            setCampaignOptions(prev =>
                pageNum === 1 ? options : [...prev, ...options] // Reset or append options based on page
            );
            setTotalCount(response.totalCount);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        // if (shouldFetchSingleCampaign === true) {
        //     return;
        // }
        if (inputValue.length >= 2) {
            fetchAndSetData(1, inputValue);
        } else if (inputValue === '') {
            fetchAndSetData(1, '');
        }
    }, [inputValue]);

    useEffect(() => {
        if (campaignId > 0 && shouldFetchSingleCampaign) {
            const fetchCampaignById = async () => {
                try {
                    setLoading(true);
                    const response = await get(`/campaigns/${campaignId}`);
                    const campaignOption = {
                        label: response.campaignName,
                        value: response.id,
                    };

                    setCampaignOptions((prev) => {
                        const campaignExists = prev.some(option => option.value === campaignOption.value);
                        if (!campaignExists) {
                            return [campaignOption, ...prev];
                        }
                        return prev;
                    });

                    setSelectedOption(campaignOption);
                } catch (error) {
                    console.error('Error fetching campaign by ID:', error);
                } finally {
                    setLoading(false);
                }
            };

            fetchCampaignById();
        }
    }, [campaignId, shouldFetchSingleCampaign]);

    const handleInputChange = (newValue) => {
        setInputValue(newValue);
        setPageNumber(1);
    };

    const handleScrollToBottom = () => {
        const totalFetched = campaignOptions.length;
        if (totalFetched < totalCount && !loading) {
            const nextPage = pageNumber + 1;
            setPageNumber(nextPage);
            fetchAndSetData(nextPage, inputValue);
        }
    };

    const customStyles = {
        control: (provided) => ({
            ...provided,
            minHeight: small ? '40px' : '56px',
            height: small ? '40px' : '56px',
            padding: '0px 8px',
            borderRadius: '4px',
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 10,
            backgroundColor: '#fff',
            borderRadius: '4px',
        }),
    };

    return (
        <div style={{ width: fullWidth ? '100%' : 'auto' }}>
            <Select
                isLoading={loading}
                isClearable
                options={campaignOptions}
                value={selectedOption}
                onChange={(selectedOption) => {
                    setCampaignId(selectedOption ? selectedOption.value : null);
                    setSelectedOption(selectedOption);
                }}
                onInputChange={handleInputChange}
                placeholder="Select Campaign"
                styles={customStyles}
                maxMenuHeight={200}
                onMenuScrollToBottom={handleScrollToBottom}
                noOptionsMessage={() => (loading ? 'Loading...' : 'No options available')}
            />
        </div>
    );
};

export default CampaignsAutoComplete;
